import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray } from "../../components/Common";
import { AreaTextField } from "../DesignerCommon";
import AreaSelectField from "../../components/AreaSelectField";
import ColourSelector from "../../components/ColourSelector";

import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import Typography from "@material-ui/core/Typography";
import ListSubheader from "@material-ui/core/ListSubheader";
import Slider from "@material-ui/core/Slider";
import MenuItem from "@material-ui/core/MenuItem";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";

import { blue } from "@material-ui/core/colors";

import {
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import { check_cyclonic, get_beam_menu_items } from "../specification_drawer/SpecBeamPostTools";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import * as CONFIG from "../../redux_store/configState";
import BSL_Select from "../../components/BSL_Select";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import BSL_TextInput from "../../components/BSL_TextInput";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { add } from "lodash";
import { useEffect } from "react";
import CrossCircleIcon from "@material-ui/icons/Cancel";
import { IconButton } from "@material-ui/core";
import BSL_Button from "../../components/BSL_Button";
import { Autocomplete } from "@mui/material";

const AttachmentSlider = withStyles({
    root: {
        color: "#3a8589",
        height: 3,
        padding: "13px 0",
        marginTop: "20px",
    },
    thumb: {
        height: "20px !important",
        width: "20px !important",
        backgroundColor: "#a90000",
        border: "2px solid #a90000",
        marginTop: "-8px !important",
        marginLeft: "-10px !important",
        borderRadius: "25%",
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit",
        },
    },
    active: {},
    valueLabel: {
        left: "calc(-50% + 3px)",
        top: 15,
        "& *": {
            background: "transparent",
            color: "#000",
        },
    },
    track: {
        height: 0,
        // background: "repeating-linear-gradient(45deg,#B1B118,#B1B118 2px,#F0F2E6 2px,#F0F2E6 10px)"
    },
    rail: {
        color: "#FFF",
        opacity: 1,
        height: 16,
        marginTop: "-8px",
        border: "2px solid #7AB004",
    },
})(Slider);

const SpanSlider = withStyles({
    root: {
        color: "#3a8589",
        height: 3,
        padding: "13px 0",
        marginTop: "20px",
    },
    thumb: {
        height: "0px !important",
        width: "0px !important",
        backgroundColor: "#a90000",
        border: "0px solid #a90000",
        marginTop: "-8px !important",
        marginLeft: "-10px !important",
    },
    active: {},
    valueLabel: {
        left: "calc(-50% + 3px)",
        top: 15,
        "& *": {
            background: "transparent",
            color: "#000",
        },
    },
    track: {
        height: 0,
        // background: "repeating-linear-gradient(45deg,#B1B118,#B1B118 2px,#F0F2E6 2px,#F0F2E6 10px)"
    },
    rail: {
        color: "#FFF",
        opacity: 0,
        height: 0,
    },
})(Slider);

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper id="draggable-dialog-title" {...props} />
        </Draggable>
    );
}

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    root: {
        width: 300,
    },
    handleText: {
        textAlign: "right",
        background: "#0000",
        width: "46px",
        border: "1px",
        // position: 'absolute',
        // top: '-25px',
    },
    attachLengthText: {
        textAlign: "center",
        width: "55px",
        border: "0px",
    },
    label: {
        width: "200%",
    },
    handleContainer: {
        display: "flex",
        top: "-25px",
        width: "60px",
        position: "absolute",
        marginLeft: "-10px",
    },
    handleEndAdornment: {
        fontSize: "0.7rem",
    },
    handleBar: {
        position: "absolute",
        left: "32px",
        top: "37px",
        color: "#f9a4a4",
        fontSize: "125%",
        fontWeight: "100",
    },
});

function valuetext(value) {
    return `{value}mm`;
}

function distanceVector(ref) {
    //format (xx/yy/zz);(xx/yy/zz)
    let split = ref.split(";");
    let p1 = split[0].replace("(", "").replace(")", "");
    let p1_split = p1.split("/");
    let p2 = split[1].replace("(", "").replace(")", "");
    let p2_split = p2.split("/");
    var dx = Number(p1_split[0]) - Number(p2_split[0]);
    var dy = Number(p1_split[1]) - Number(p2_split[1]);
    var dz = Number(p1_split[2]) - Number(p2_split[2]);

    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

export default function SpecModifyBeamDialog(props) {
    const classes = useStyles();
    const sliderRef = React.useRef(null);
    const dispatch = useDispatch();
    const { onClose, selectedValue, open, item } = props;
    const logged_user_code = useSelector((state) => state.app.logged_user_code);
    const user = useSelector((state) => state.app.user);
    const config = useSelector((state) => state.config);
    const ConfigDesignOptions = useSelector((state) => state.config.design_options);
    const beam_types = useSelector((state) => state.config.beam_types);
    const post_types = useSelector((state) => state.config.post_types);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const job = useSelector((state) => state.job);
    let areaIndex = item.areaIndex ? item.areaIndex : 0;
    const area_BEAMS_AND_POSTS = AreaSpecifications[item.areaIndex].BEAMS_AND_POSTS;
    const BeamPostParameters = area_BEAMS_AND_POSTS;
    const area0DataBeamSpecMods = AreaSpecifications[0].BEAMSPECMODIFICATIONS;
    const areaDataBeamSpecAreaMods = AreaSpecifications[item.areaIndex].BEAMSPECMODIFICATIONS;
    const areaDataBeamAdj = AreaSpecifications[item.areaIndex].BEAMADJUSTMENTS;
    const areaDataBeamExtend = AreaSpecifications[item.areaIndex].BeamWallExtends;
    const designType = AreaSpecifications[item.areaIndex].SHAPE.DesignType;
    const design_options = ConfigDesignOptions[designType];

    const ref = item ? item.ref : null;
    let ref2 = item ? item.ref2 : null;

    if (ref2) {
        ref2 = ref2.replace("Portal1/", "Portal/");
        ref2 = ref2.replace("Portal2/", "Portal/");
    }

    const ref4 = item ? item.ref4 : null;
    const beam_length = item && item.lengthQQ ? item.lengthQQ : Math.round(distanceVector(ref));
    let max_overhang = Math.min(beam_length / 4, 1000);

    const filtered_area0DataBeamSpecMods = area0DataBeamSpecMods.filter((mod) => {
        return mod.Area === undefined || mod.Area === item.areaIndex;
    });

    const filtered_areaDataBeamSpecMods = areaDataBeamSpecAreaMods.filter((mod) => {
        return mod.Area === undefined || mod.Area === item.areaIndex;
    });

    // get from area settings first, then area 0
    let data_mods = getItemFromArray(filtered_areaDataBeamSpecMods, "Ref", ref, "Ref2", ref2, 30, 90, true);
    if (!data_mods) {
        data_mods = getItemFromArray(filtered_area0DataBeamSpecMods, "Ref", ref, "Ref2", ref2, 30, 90, true);
    }
    let data_adj = getItemFromArray(areaDataBeamAdj, "Ref", ref2, null, null, 30, 90, true);
    let data_extend = getItemFromArray(areaDataBeamExtend, "Ref", ref, "Ref4", ref4, 30, 90, true);
    // if (data_mods?.Extend1 !== undefined) {
    //     data_extend = data_mods;
    // }

    let beamType = item?.typeQQ ? item?.typeQQ : "beam1";
    if (item.typeQQ && item.typeQQ == "beam") {
        if (item.nameQQ.startsWith("FB")) beamType = "beam1";
        if (item.nameQQ.startsWith("CB")) beamType = "beam1";
        if (item.nameQQ.startsWith("P") || (item.ref2 && item.ref2.includes("Purlin"))) beamType = "beam2";
        if (item.nameQQ.startsWith("R")) beamType = "beam3";
        if (item.nameQQ.startsWith("SF")) beamType = "beam3";
        if (item.nameQQ.startsWith("EB")) beamType = "beam3";
        else beamType = "beam1";
    }

    //defaults MODIFICATIONS
    let defaultBeamType = area_BEAMS_AND_POSTS.BeamType1;
    if (beamType === "beam2") defaultBeamType = area_BEAMS_AND_POSTS.BeamType2;
    if (beamType === "beam3") defaultBeamType = area_BEAMS_AND_POSTS.BeamType3;
    if (beamType === "beam4") defaultBeamType = area_BEAMS_AND_POSTS.BeamType4;
    if (item?.typeQQ === "beam" && item.beamSection) defaultBeamType = item.beamSection;

    let defaultPostType = area_BEAMS_AND_POSTS.PostType;
    let posttype = post_types[defaultPostType];

    let first_post_adj = posttype.depth / 2;
    let last_post_adj = posttype.depth / 2;

    // const AUTO = "Auto";
    // const NONE = "None";
    // const END_1 = "End 1";
    // const END_2 = "End 2";
    // const BOTH = "Both";

    // let default_beam_extend = AUTO;
    // if (data_mods?.Extend1 !== undefined) {
    //     if (data_mods.Extend1 == 2) default_beam_extend = END_1;
    //     if (data_mods.Extend2 == 2) {
    //         if (default_beam_extend === END_1) default_beam_extend = BOTH;
    //         else default_beam_extend = END_2;
    //     }
    //     if (data_mods.Extend1 == 0 && data_mods.Extend2 == 0) default_beam_extend = NONE;
    // } else if (data_extend) {
    //     if (data_extend.Extend1 == 1) default_beam_extend = END_1;
    //     if (data_extend.Extend2 == 1) {
    //         if (default_beam_extend === END_1) default_beam_extend = BOTH;
    //         else default_beam_extend = END_2;
    //     }
    //     if (data_extend.Extend1 == 0 && data_extend.Extend2 == 0) default_beam_extend = NONE;
    // }

    // const [extendUnderEave, setExtendUnderEave] = React.useState(default_beam_extend);
    const [extend1, setExtend1] = React.useState(data_mods?.Extend1 ? data_mods.Extend1 : 1); //1 AUTO, 2 EXTEND, 0 DONT EXTEND, >10 extend by x mm
    const [extend2, setExtend2] = React.useState(data_mods?.Extend2 ? data_mods.Extend2 : 1); //1 AUTO, 2 EXTEND, 0 DONT EXTEND, >10 extend by x mm

    const [newSupportName, set_NewSupportName] = React.useState("");
    const [newPosition, set_NewPosition] = React.useState("");

    const [supports, setSupports] = React.useState(
        data_mods?.Supports ? data_mods?.Supports : item?.supports ? item?.supports : ""
    );

    let support_data = [];
    if (supports?.split) {
        let support_split = supports.split(";");
        for (let support of support_split) {
            let data_split = support.split("/");
            support_data.push({
                data: support,
                element_name: data_split[0],
                end: data_split[1],
                side: data_split[2],
                location: toNumber(data_split[3]),
                bracket: data_split[4],
            });
        }
    }

    const updateSupport = (index, parameter, value) => {
        support_data[index][parameter] = value;
        updateSupportData(support_data);
    };
    const deleteSupport = (index) => {
        support_data.splice(index, 1);
        updateSupportData(support_data);
    };

    const updateSupportData = (_support_data) => {
        _support_data.sort((a, b) => {
            let a_location = a.location === "" ? 99999999 : a.location;
            let b_location = b.location === "" ? 99999999 : b.location;
            return a_location - b_location;
        });
        let support_string = "";
        for (let support of _support_data) {
            if (support.element_name.trim() !== "" && support.location !== "") {
                if (support_string !== "") support_string += ";";
                support_string +=
                    support.element_name +
                    "/" +
                    support.end +
                    "/" +
                    support.side +
                    "/" +
                    support.location +
                    "/" +
                    support.bracket;
            }
        }
        setSupports(support_string);
    };

    useEffect(() => {
        if (newPosition !== "" && newSupportName.trim() !== "") {
            support_data.push({
                data: "",
                element_name: newSupportName,
                end: "",
                side: "",
                location: toNumber(newPosition),
                bracket: "",
            });
            updateSupportData(support_data);
            set_NewSupportName("");
            set_NewPosition("");
        }
    }, [newSupportName, newPosition]);

    const [sectionValue, setSectionValue] = React.useState(
        data_mods && data_mods.Section ? data_mods.Section : defaultBeamType
    );
    // const handleSectionValue = (event) => {
    //     //
    //     setSectionValue(event.target.value);
    // };

    let defaultBeamColour = area_BEAMS_AND_POSTS.BeamCol1;
    if (item.colour && item.beam_name && item.beam_name.startsWith("U")) defaultBeamColour = item.colour;
    if (beamType === "beam2") defaultBeamColour = area_BEAMS_AND_POSTS.BeamCol2;
    if (beamType === "beam3") defaultBeamColour = area_BEAMS_AND_POSTS.BeamCol3;
    if (beamType === "beam4") defaultBeamColour = area_BEAMS_AND_POSTS.BeamCol4;

    let beam_type_index = 1;
    if (beamType === "beam2") beam_type_index = 2;
    if (beamType === "beam3") beam_type_index = 3;
    if (beamType === "beam4") beam_type_index = 4;

    const [colourValue, setColourValue] = React.useState(
        data_mods && data_mods.Colour ? data_mods.Colour : defaultBeamColour
    );
    const handleColourValue = (event, newValue) => {
        setColourValue(newValue !== undefined ? newValue : event.target.value);
    };

    const [lengthValue, setLengthValue] = React.useState(data_mods && data_mods.Length ? data_mods.Length : " ");
    const handleLengthValue = (event, newValue) => {
        setLengthValue(newValue !== undefined ? newValue : event.target.value);
    };

    //defaults ADJUSMTNETR
    const split = item.adj ? item.adj.split("/") : [0, 0];
    const default_adjustment = data_adj ? Number(data_adj.Adjustment) : 0;
    const min_adj = -Number(split[0]) + default_adjustment;
    const max_adj = Number(split[1]) + default_adjustment;

    const [adjustmentValue, setAdjustmentValue] = React.useState(default_adjustment);
    const handleAdjustmentValue = (event, newValue) => {
        setAdjustmentValue(newValue !== undefined ? newValue : event.target.value);
    };

    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    const handleReset = () => {
        setSectionValue(defaultBeamType);
        setColourValue(defaultBeamColour);
        setLengthValue(" ");
        setAdjustmentValue(0);
        if (item?.supports) setSupports(item.supports);
    };

    const saveBeamModifications = () => {
        let new_data_mods = data_mods ? { ...data_mods } : {};
        new_data_mods.P1 = ref.split(";")[0].replaceAll("/", ",");
        new_data_mods.P2 = ref.split(";")[1].replaceAll("/", ",");
        new_data_mods.Ref = ref;
        new_data_mods.Ref2 = ref2 ? ref2 : "";

        new_data_mods.Area = item.areaIndex;
        new_data_mods.Section = sectionValue !== defaultBeamType ? sectionValue : "";
        new_data_mods.Colour = colourValue !== defaultBeamColour ? colourValue : "";
        let length = toNumber(lengthValue);
        new_data_mods.Length = length ? length : "";
        new_data_mods.Extend1 = extend1 !== 1 ? extend1 : "";
        new_data_mods.Extend2 = extend2 !== 1 ? extend2 : "";
        // new_data_mods.Extend1 = extendUnderEave === END_1 || extendUnderEave === BOTH ? 2 : 0;
        // new_data_mods.Extend2 = extendUnderEave === END_2 || extendUnderEave === BOTH ? 2 : 0;

        new_data_mods.Supports = supports !== item?.supports ? supports : "";

        // if (extendUnderEave === AUTO) {
        //     new_data_mods.Extend1 = 1;
        //     new_data_mods.Extend2 = 1;
        // }
        // new_data_mods.Overhang1 = overhang1Value ? overhang1Value : 0;
        // new_data_mods.Overhang2 = overhang2Value ? overhang2Value : 0;
        // new_data_mods.NumInternalPosts = numInternalPostsValue ? numInternalPostsValue : 0;
        // new_data_mods.EvenlySpacePosts = evenlySpacePosts;

        // let new_internalPostOffsetsValues = [...internalPostOffsetsValues];
        //
        // new_internalPostOffsetsValues.splice(new_internalPostOffsetsValues.indexOf(overhang1Value), 1);
        // new_internalPostOffsetsValues.splice(new_internalPostOffsetsValues.indexOf((beam_length-overhang2Value)), 1);
        //

        // new_data_mods.InternalPostOffsets = internalPostOffsetsValues && !evenlySpacePosts ? new_internalPostOffsetsValues : "";
        //

        if (
            new_data_mods.Section ||
            new_data_mods.Colour ||
            new_data_mods.Length ||
            new_data_mods.Extend1 !== 1 ||
            new_data_mods.Extend2 !== 1 ||
            new_data_mods.Supports !== ""
            // || new_data_mods.Overhang1
            // || new_data_mods.Overhang2
            // || new_data_mods.NumInternalPosts
        ) {
            dispatch(
                updateAreaSpecificationModificationArray(
                    item.areaIndex,
                    "BEAMSPECMODIFICATIONS",
                    ref,
                    null,
                    new_data_mods,
                    true,
                    ref2
                )
            );
        } else {
            //delete paat from list
            dispatch(
                deleteFromAreaSpecificationModificationArray(
                    item.areaIndex,
                    "BEAMSPECMODIFICATIONS",
                    ref,
                    30,
                    "Ref2",
                    ref2,
                    "Ref2",
                    ref2
                )
            ).then(() => {
                dispatch(
                    deleteFromAreaSpecificationModificationArray(
                        item.areaIndex,
                        "BeamWallExtends",
                        ref4,
                        60,
                        undefined,
                        undefined,
                        "Ref4",
                        ref4
                    )
                );
            });
        }

        // if (
        //     extendUnderEave !== AUTO
        //     // || new_data_mods.Overhang1
        //     // || new_data_mods.Overhang2
        //     // || new_data_mods.NumInternalPosts
        // ) {
        //     let new_data_extend = data_extend ? { ...data_extend } : {};
        //     new_data_extend.Ref = ref4;
        //     new_data_extend.Ref2 = ref4;
        //     new_data_extend.Ref4 = ref4;
        //     new_data_extend.P1 = ref4.split(";")[0].replaceAll("/", ",");
        //     new_data_extend.P2 = ref4.split(";")[1].replaceAll("/", ",");
        //     new_data_extend.Extend1 = extendUnderEave === END_1 || extendUnderEave === BOTH ? 1 : 0;
        //     new_data_extend.Extend2 = extendUnderEave === END_2 || extendUnderEave === BOTH ? 1 : 0;

        //     // new_data_extend.Extend1 = item?.E1 === "End Cap" || item?.E1 === "B" ? -1 : extendUnderEave;
        //     // new_data_extend.Extend2 = item?.E2 === "End Cap" || item?.E2 === "B" ? -1 : extendUnderEave;

        //     // { Key: "Auto", Display: "Auto" },
        //     // { Key: "None", Display: "Don't Extend" },
        //     // { Key: "End 1", Display: "Extend End 1" },
        //     // { Key: "End 2", Display: "Extend End 2" },
        //     // { Key: "Both", Display: "Extend Both Ends" },

        //     dispatch(
        //         updateAreaSpecificationModificationArray(
        //             item.areaIndex,
        //             "BeamWallExtends",
        //             ref4,
        //             null,
        //             new_data_extend,
        //             true,
        //             ref4
        //         )
        //     );
        // } else {
        //     //delete paat from list
        //
        //     dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "BeamWallExtends", ref4));
        // }

        if (ref2) {
            let new_data_adj = data_adj ? { ...data_adj } : {};
            new_data_adj.Ref = ref2 ? ref2 : "";
            new_data_adj.Section = ref2.split("/")[0];
            new_data_adj.Num = ref2.split("/")[1];
            new_data_adj.Adjustment = adjustmentValue;

            // if (new_data_adj.Section === "Portal1") new_data_adj.Section = "Portal";
            // if (new_data_adj.Section === "Portal2") new_data_adj.Section = "Portal";

            if (new_data_adj.Adjustment) {
                dispatch(
                    updateAreaSpecificationModificationArray(
                        item.areaIndex,
                        "BEAMADJUSTMENTS",
                        ref2,
                        null,
                        new_data_adj,
                        true
                    )
                );
            } else {
                //delete paat from list
                dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "BEAMADJUSTMENTS", ref2, true));
            }
        }

        onClose();

        // new_data_paat.Name = ref;
        // let p1 = paatValues[0];
        // let p2 = paatValues[1];
        // let attach_length = p2 - p1;
        // if (attach_length >= max) {
        //   //delete paat from list
        //   dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.PARTIAL_ATTACHMENTS", ref, false));
        // }
        // else
        // {
        //   if (p1 > 0 && p2 >= max-10) {
        //     new_data_paat.Kind = "NA";
        //     new_data_paat.Length = attach_length;
        //     new_data_paat.Offset = p1;
        //   }
        //   else if (p1 <= 10) {
        //     new_data_paat.Kind = "AN";
        //     new_data_paat.Length = attach_length;
        //     new_data_paat.Offset = p1;
        //   }
        //   else {
        //     new_data_paat.Kind = "NAN";
        //     new_data_paat.Length = attach_length;
        //     new_data_paat.Offset = p1;
        //   }
        //   new_data_paat.HasGutter = paatGutterValue?0:1;

        //   dispatch(updateAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.PARTIAL_ATTACHMENTS", ref, null, new_data_paat, false));
        // }

        // let new_data_mods = data_mods?{...data_mods}:{};
        // new_data_mods.Ref = ref;
        // new_data_mods.Name = ref;

        // new_data_mods.AttachmentLabel = attachmentLabel;
        // new_data_mods.EaveWidth = isNaN(eaveValue)?"":Number(eaveValue);
        // new_data_mods.HasEaveWidth = (new_data_mods.EaveWidth !== "" && new_data_mods.EaveWidth !== default_EaveDepth) ? 1:0;
        // new_data_mods.WallHeight = isNaN(wallHeightValue)?"":Number(wallHeightValue);
        // new_data_mods.HasWallHeight = (new_data_mods.WallHeight !== "" && new_data_mods.WallHeight !== default_WallHeight) ? 1:0;
        // new_data_mods.FasciaType = fasciaTypeValue;
        // new_data_mods.HasFasciaType = (new_data_mods.FasciaType !== "" && new_data_mods.FasciaType !== default_FasciaType)? 1:0;
        // new_data_mods.NumBrackets = isNaN(numBrackets)?0:Number(numBrackets);
        // if (!new_data_mods.NumBrackets) new_data_mods.NumBrackets = 0;
        // if (new_data_mods.NumBrackets > max_rafters) new_data_mods.NumBrackets = max_rafters;
        // if (new_data_mods.NumBrackets < min_rafters) new_data_mods.NumBrackets = 0;

        // new_data_mods.HasNumBrackets = (new_data_mods.NumBrackets !== "" && new_data_mods.NumBrackets >= min_rafters)? 1:0;
        // new_data_mods.AllowRSBLC = rSBLC?1:0;

        // //

        // if (new_data_mods.HasEaveWidth
        //   || new_data_mods.HasWallHeight
        //   || new_data_mods.HasFasciaType
        //   || new_data_mods.HasNumBrackets
        //   || new_data_mods.AttachmentLabel !== "") {
        //     dispatch(updateAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.AttachmentModifications", ref, null, new_data_mods, true));
        // }
        // else
        // {
        //   //delete paat from list
        //   dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.AttachmentModifications", ref, true));
        // }
    };

    // MODS

    // Name:"Back 1",
    // HasEaveWidth:0,
    // EaveWidth:35,
    // HasWallHeight:0,
    // WallHeight:2500,
    // HasFasciaType:0,
    // FasciaType:"Beam",
    // AttachmentLabel:"werwer",
    // HasNumBrackets:1,
    // NumBrackets:44,
    // HasBracketType:0,
    // AllowRSBLC:1,

    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    const beam_spec = design_options[beamType.replace("beam", "beam_")];

    let beam_menu_items = get_beam_menu_items(config, job, beam_type_index, areaIndex, is_cyclonic, beam_length);
    // for (let key in beam_spec.options) {
    //     beam_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);
    //     for (let key2 of beam_spec.options[key]) {
    //         const beam = beam_types?.[key2];
    //         if (beam) {
    //             let id = beam.id ? beam.id : key2;
    //             let name = beam.name ? beam.name : key2;
    //
    //             if (check_cyclonic(beam_spec?.disabled_on_cyclonic, key2, is_cyclonic)) continue;
    //             if (beam)
    //                 beam_menu_items.push(
    //                     <MenuItem key={id} value={key2}>
    //                         {beam.thumbnail && (
    //                             <div key={id} className={classes.roofsheet_chip}>
    //                                 <img alt="sheet thumb" src={beam.thumbnail} style={{ height: "32px" }} />
    //                             </div>
    //                         )}
    //                         {name}
    //                     </MenuItem>
    //                 );
    //         }
    //     }
    // }

    let beam_shift_helper_text =
        "Min: " +
        min_adj +
        "mm /Max=" +
        max_adj +
        "mm, *a negative number will move the beam towards the front fascia, or to the left.";
    if (min_adj >= max_adj) beam_shift_helper_text = "Beam Shift disabled as this beam cannot be moved.";

    const area_design_specs = AreaSpecifications?.[item.areaIndex];

    //DES-1678 In case of Portal Gable, disable beam spec and hide "Extend beam under Eave to Wall" functionality.
    let is_gable = area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;

    // let disable_beam_selection = false;
    // let disable_helper_text = "";
    // if (is_gable && beamType === "beam1") {
    //     disable_beam_selection = true;
    //     disable_helper_text = "Rafter type cannot be individually changed in a Gable design";
    // }

    let colourMatch = {
        "Match Post": BeamPostParameters.PostCol,
        "Match Area 1 Post": job?.AreaSpecifications?.[0]?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.PostCol,
    };

    // internal static string[] SUPPORT_DATA_FORMAT = new string[] { "NAME", "END", "SIDE", "LOCATION", "BRACKET", "LOCATION_ON_SUPPORT" };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: "move" }}>Modify Beam Options</DialogTitle>
            {window.debug && (
                <Typography id="range-slider" variant="caption" gutterBottom>
                    {"ref " + ref + " / ref2 " + ref2 + " / ref4 " + ref4}
                </Typography>
            )}
            <DialogContent style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
                {!item && <DialogContentText>Beam data is not defined</DialogContentText>}
                {item && (
                    <DialogContentText style={{ display: "flex", flexDirection: "column" }}>
                        <Typography id="range-slider" gutterBottom>
                            Modify Beam Specifications
                        </Typography>
                        {/* <AreaSelectField
                            dark
                            value={sectionValue}
                            items={beam_menu_items}
                            clip_overflow
                            onChange={handleSectionValue}
                            disabled={disable_beam_selection}
                        /> */}
                        <BSL_Select
                            style={{ flex: 1 }}
                            selectStyle={{}}
                            // value={BeamPostParameters.BeamType1}
                            value={sectionValue}
                            // tight={true}
                            items={beam_menu_items}
                            onChange={(event) => {
                                setSectionValue(event.target.value);
                            }}
                            // disabled={disable_beam_selection}
                            // helperText={disable_helper_text}
                            // onChange={updateBeamPostData("BeamType1")}
                        />
                        <BSL_ColourSelector
                            // tight
                            // label="Colour"
                            // colourList={beam_spec.colours}
                            colourList={["Match Post", "TBA", beam_spec.colours]}
                            // value={BeamPostParameters.BeamColMatchBeam}
                            value={colourValue}
                            // onChange={updateBeamPostData("BeamColMatchBeam")}
                            onChange={(val) => handleColourValue(null, val)}
                            colourMatch={colourMatch}
                            // style={{
                            //     marginTop: "-12px",
                            // }}
                        />

                        {/* <ColourSelector
                            dark
                            colourList={beam_spec.colours}
                            value={colourValue}
                            onChange={(e) => handleColourValue(null, e.target.value)}
                            id="Beam_colour"
                            style={{ width: "100%", textAlign: "left" }}
                        /> */}
                        {/* <AreaTextField
                            root_style={{ width: "160px" }}
                            style={{ width: "107px" }}
                            label="Order Beam Length"
                            dark
                            value={lengthValue}
                            adornmentText="mm"
                            allowZero
                            min={100}
                            max={beam_length + 2000}
                            blurOnEnter={true}
                            onBlur={(val) => {
                                handleLengthValue(null, val);
                            }}
                            helperTextStyle={{ whiteSpace: "nowrap" }}
                            helperText={
                                "this will only affect the BOM, not the design. Original length: " + beam_length + "mm"
                            }
                        /> */}
                        <BSL_TextInput
                            label="Order Beam Length"
                            placeholder={beam_length}
                            value={lengthValue}
                            tight
                            allowZero
                            min={100}
                            max={beam_length + 2000}
                            endAdornment="mm"
                            onBlur={(val) => {
                                handleLengthValue(null, val);
                            }}
                            style={{
                                width: "160px",
                                marginTop: "-4px",
                                paddingTop: "0px",
                            }}
                            inputPropsStyle={{
                                width: "130px",
                            }}
                            helperTextStyle={{ whiteSpace: "nowrap" }}
                            helperText={
                                "this will only affect the BOM, not the design. Original length: " + beam_length + "mm"
                            }
                        />

                        {ref2 && min_adj !== 0 && max_adj !== 0 && (
                            <>
                                <Typography id="range-slider" gutterBottom>
                                    Shift Beam
                                </Typography>
                                <AreaTextField
                                    disabled={min_adj >= max_adj}
                                    dark
                                    value={adjustmentValue}
                                    adornmentText="mm"
                                    allowZero
                                    min={min_adj}
                                    max={max_adj}
                                    blurOnEnter={true}
                                    onBlur={(val) => {
                                        handleAdjustmentValue(null, val);
                                    }}
                                    helperText={beam_shift_helper_text}
                                />
                            </>
                        )}
                        {!is_gable && (
                            <>
                                <Typography
                                    id="range-slider"
                                    gutterBottom
                                    style={{ marginTop: "10px", marginBottom: "0px" }}
                                >
                                    Extend Beam
                                </Typography>
                                <BSL_Common.SectionRow style={{ marginLeft: "16px", marginTop: "-8px" }}>
                                    <div
                                        style={{
                                            borderRadius: "50%",
                                            width: "20px",
                                            height: "20px",
                                            marginTop: "14px",
                                            marginLeft: "-10px",
                                            marginRight: "2px",
                                            border: "3px dotted darkgreen",
                                        }}
                                    ></div>
                                    <div
                                        style={{
                                            fontSize: 15,
                                            paddingTop: 18,
                                            paddingLeft: 5,
                                            minWidth: "42px",
                                        }}
                                    >
                                        End 1
                                    </div>
                                    <SegmentedButtonGroup
                                        value={extend1 >= 3 ? 3 : extend1}
                                        items={[
                                            { Key: 1, Display: "Auto" },
                                            { Key: 0, Display: "Don't Extend" },
                                            { Key: 2, Display: "Extend Under Eave*" },
                                            { Key: 3, Display: "Custom" },
                                        ]}
                                        onChange={(e, v) => {
                                            setExtend1(v);
                                        }}
                                        style={{ flex: "none" }}
                                    />
                                    {Math.abs(extend1) >= 3 && (
                                        <BSL_TextInput
                                            value={Math.abs(extend1) <= 3 ? 0 : extend1}
                                            tight
                                            min={-9999}
                                            max={9999}
                                            endAdornment="mm"
                                            onBlur={(val) => {
                                                if (val < 0 && val > -10) {
                                                    val = -10;
                                                } else if (val > 0 && val < 10) {
                                                    val = 10;
                                                }
                                                setExtend1(val);
                                            }}
                                            style={{
                                                marginTop: "10px",
                                                paddingTop: "0px",
                                                marginLeft: "2px",
                                            }}
                                            inputPropsStyle={{
                                                width: "75px",
                                            }}
                                            helperTextStyle={{ whiteSpace: "nowrap" }}
                                        />
                                    )}
                                </BSL_Common.SectionRow>
                                <BSL_Common.SectionRow style={{ marginLeft: "16px", marginTop: "-20px" }}>
                                    <div
                                        style={{
                                            borderRadius: "50%",
                                            width: "20px",
                                            height: "20px",
                                            marginTop: "14px",
                                            marginLeft: "-10px",
                                            marginRight: "2px",
                                            border: "3px dotted darkred",
                                        }}
                                    ></div>
                                    <div
                                        style={{
                                            fontSize: 15,
                                            paddingTop: 18,
                                            paddingLeft: 5,
                                            minWidth: "42px",
                                        }}
                                    >
                                        End 2
                                    </div>
                                    <SegmentedButtonGroup
                                        value={extend2 >= 3 ? 3 : extend2}
                                        items={[
                                            { Key: 1, Display: "Auto" },
                                            { Key: 0, Display: "Don't Extend" },
                                            { Key: 2, Display: "Extend Under Eave*" },
                                            { Key: 3, Display: "Custom" },
                                        ]}
                                        onChange={(e, v) => {
                                            setExtend2(v);
                                        }}
                                        style={{ flex: "none" }}
                                        helperText={"*only applies to beams attached to fascia"}
                                    />

                                    {Math.abs(extend2) >= 3 && (
                                        <BSL_TextInput
                                            value={Math.abs(extend2) <= 3 ? 0 : extend2}
                                            tight
                                            min={-9999}
                                            max={9999}
                                            endAdornment="mm"
                                            onBlur={(val) => {
                                                if (val < 0 && val > -10) {
                                                    val = -10;
                                                } else if (val > 0 && val < 10) {
                                                    val = 10;
                                                }
                                                setExtend2(val);
                                            }}
                                            style={{
                                                marginTop: "10px",
                                                paddingTop: "0px",
                                                marginLeft: "2px",
                                            }}
                                            inputPropsStyle={{
                                                width: "75px",
                                            }}
                                            helperTextStyle={{ whiteSpace: "nowrap" }}
                                        />
                                    )}
                                </BSL_Common.SectionRow>
                            </>
                        )}

                        {user.Role >= 92 && (
                            <div
                                style={{
                                    background: "antiquewhite",
                                }}
                            >
                                <Typography id="range-slider" gutterBottom>
                                    ADMIN TOOLS - EDIT SUPPORTS
                                </Typography>
                                {window.debug && (
                                    <BSL_TextInput
                                        label="Modify Beam Supports"
                                        placeholder={beam_length}
                                        value={supports}
                                        tight
                                        onBlur={(val) => {
                                            setSupports(val);
                                        }}
                                        style={{
                                            width: "100%",
                                            marginTop: "-4px",
                                            paddingTop: "0px",
                                        }}
                                        helperText={"original:" + item?.supports}
                                        // inputPropsStyle={{
                                        //     width: "130px",
                                        // }}
                                    />
                                )}
                                {support_data.map((item, index) => (
                                    <BSL_Common.SectionRow
                                        style={{
                                            marginTop: "-12px",
                                        }}
                                    >
                                        <BSL_TextInput
                                            label={index === 0 ? "Element Name" : ""}
                                            placeholder={"Add New"}
                                            value={item.element_name}
                                            tight
                                            onBlur={(val) => {
                                                updateSupport(index, "element_name", val);
                                            }}
                                            style={{
                                                maxWidth: "120px",
                                                marginTop: "-4px",
                                                padding: "0px",
                                            }}
                                            // inputPropsStyle={{
                                            //     width: "130px",
                                            // }}
                                        />

                                        <BSL_TextInput
                                            label={index === 0 ? "Location" : ""}
                                            value={item.location}
                                            tight
                                            allowZero
                                            min={0}
                                            max={beam_length}
                                            onBlur={(val) => {
                                                updateSupport(index, "location", val);
                                            }}
                                            style={{
                                                maxWidth: "120px",
                                                marginTop: "-4px",
                                                padding: "0px",
                                            }}
                                            endAdornment={"mm"}
                                            // inputPropsStyle={{
                                            //     width: "130px",
                                            // }}
                                        />
                                        <IconButton
                                            aria-label="delete"
                                            size="small"
                                            style={{
                                                marginTop: "-4px",
                                                alignSelf: "self-end",
                                                paddingBottom: "6px",
                                            }}
                                            onClick={() => {
                                                deleteSupport(index);
                                            }}
                                        >
                                            <CrossCircleIcon fontSize="inherit" />
                                        </IconButton>
                                    </BSL_Common.SectionRow>
                                ))}
                                <BSL_Common.SectionRow
                                    style={{
                                        marginTop: "6px",
                                    }}
                                >
                                    <BSL_TextInput
                                        placeholder={"Add New"}
                                        value={newSupportName}
                                        tight
                                        onBlur={(val) => {
                                            set_NewSupportName(val);
                                            // addNewSupport("element_name", val);
                                            // updateSupport(index, "element_name", val);
                                        }}
                                        style={{
                                            maxWidth: "120px",
                                            marginTop: "-4px",
                                            padding: "0px",
                                        }}
                                        // inputPropsStyle={{
                                        //     width: "130px",
                                        // }}
                                    />
                                    <BSL_TextInput
                                        placeholder={beam_length}
                                        value={newPosition}
                                        tight
                                        allowZero
                                        min={0}
                                        max={beam_length}
                                        onBlur={(val) => {
                                            set_NewPosition(val);
                                            // addNewSupport("location", val);
                                            // updateSupport(index, "location", val);
                                        }}
                                        style={{
                                            maxWidth: "120px",
                                            marginTop: "-4px",
                                            padding: "0px",
                                        }}
                                        endAdornment={"mm"}
                                        // inputPropsStyle={{
                                        //     width: "130px",
                                        // }}
                                    />
                                    <BSL_Button
                                        color="primary"
                                        style={{
                                            height: "24px",
                                            position: "absolute",
                                            right: "100px",
                                        }}
                                        onClick={() => {
                                            if (item?.supports) setSupports(item.supports);
                                        }}
                                    >
                                        RESET
                                    </BSL_Button>
                                </BSL_Common.SectionRow>
                            </div>
                        )}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleReset}
                    color="primary"
                    style={{
                        position: "absolute",
                        left: "20px",
                    }}
                >
                    Reset
                </Button>
                <Button autoFocus onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={saveBeamModifications} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

SpecModifyBeamDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
